'use client';

import { useTranslation } from 'react-i18next';
import { formatCurrency } from '@/lib/currency';

/** A public minimum for external checkout; never infer a free ticket from missing prices. */
export function ExternalEventPrice({
    price,
    available,
    currency,
    className,
}: {
    price?: number;
    available?: boolean;
    currency: string;
    className?: string;
}) {
    const { t, i18n } = useTranslation('product');
    const label =
        available === false
            ? t('eventCourse.ticketsUnavailable')
            : price === undefined
              ? t('eventCourse.checkEventbritePrice')
              : price === 0
                ? t('eventCourse.freePrice')
                : t('eventCourse.priceFrom', { price: formatCurrency(price, i18n.language, currency) });

    return <span className={className}>{label}</span>;
}
